import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import EverSignDocumentsService from "./EverSignDocumentsService";

const initialState = {
    documents: [],
    document: [],
    isSuccess: false,
    isError: false,
    isLoading: false,
    errors: [],
};

export const GetAllEverSignDocuments = createAsyncThunk(
    "document/index",
    async (data, thunkApi) => {
        let { rejectWithValue, getState } = thunkApi;
        try {
            let token = getState().auth.mainUser.data.token;
            return await EverSignDocumentsService.GetAllEverSignDocuments(
                data,
                token
            );
        } catch (error) {
            let message = error.message;
            return rejectWithValue(message);
        }
    }
);

const EverSignDocumentsSlice = createSlice({
    name: "eversign_documents",
    initialState,
    reducers: {
        documentReset: (state) => {
            state.isSuccess = false;
            state.isError = false;
            state.isLoading = false;
            state.errors = [];
        },
    },
    extraReducers: {
        [GetAllEverSignDocuments.pending]: (state) => {
            state.isLoading = true;
        },
        [GetAllEverSignDocuments.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isSuccess = true;
            state.documents = action.payload;
        },
        [GetAllEverSignDocuments.rejected]: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.errors = action.payload;
        },
    },
});

export const { documentReset } = EverSignDocumentsSlice.actions;
export default EverSignDocumentsSlice.reducer;
